export const ui: Record<string, string> = {
	ui_abandonGameDialogContent: "Are you sure about that?",
	ui_abandonGameDialogHeader: "You are about to abandon your game",
	ui_abandonGameDialogTitle: "Abandon game",
	ui_btnBack: "Back",
	ui_btnCancel: "Cancel",
	ui_btnClassicPreset: "Classic",
	ui_btnContinue: "Continue",
	ui_btnKeepPlaying: "Keep Playing",
	ui_btnLoadGame: "Load Game",
	ui_btnMenu: "Menu",
	ui_btnModernPreset: "Modern",
	ui_btnNewGame: "New Game",
	ui_btnNewGameExperimental: "New Game - Experimental",
	ui_btnPlayTutorial: "Play Tutorial",
	ui_btnQuit: "Quit",
	ui_btnQuitToDesktop: "Quit to Desktop",
	ui_btnQuitToMenu: "Quit to Menu",
	ui_btnResume: "Resume",
	ui_btnResetHints: "Show beginner hints again",
	ui_btnSave: "Save",
	ui_btnSettings: "Settings",
	ui_btnTutorial: "Tutorial",
	ui_characterSelectTitle: "Choose your character",
	ui_characterSelectSubtitle: "Characters differ only in their starting loadout",
	ui_checkBoxMovementAnimations: "Movement animations",
	ui_checkBoxSkipTutorial: "Skip tutorial",
	ui_checkBoxSoundEffects: "Sound effects",
	ui_confirmLoseGame: "Your current game will be lost. Are you sure?",
	ui_gameOverLabel: "GAME OVER",
	ui_labelAnimationSpeed: "Animation Speed",
	ui_btnCopySeed: "Copy",
	ui_labelCameraFollowPlayer: "Camera Follow Player",
	ui_labelCopied: "Copied!",
	ui_labelAnimationSpeedFactor: "Animations speed factor:",
	ui_labelGraphics: "Graphics:",
	ui_labelGold: "Cash:",
	ui_labelHealth: "Health:",
	ui_labelHintsReset: "Hints reset",
	ui_lockedLabel: "LOCKED",
	ui_labelInventory: "Inventory",
	ui_labelLanguage: "Language:",
	ui_labelPaused: "Paused",
	ui_labelPresets: "Presets:",
	ui_labelSavesNotImplementedYet: "(save games are not implemented yet)",
	ui_labelSettings: "Settings",
	ui_labelSoundEffects: "Sound Effects",
	ui_labelSoundVolume: "Sound Volume",
	ui_labelMusic: "Music",
	ui_labelMusicVolume: "Music Volume",
	ui_labelTelemetry: "Share anonymous gameplay stats",
	ui_telemetryNote:
		"Anonymous stats only. No personal data. IP is used briefly for country lookup and abuse protection, never stored.",
	ui_labelVictory: "VICTORY!",
	ui_labelVictoryMessage: "Congratulations, you won!\n\nHope you liked the game. \nThis is a beta version that is still being worked on. \n\nIf you have any suggestion or ideas, please send them to the developer.",
	ui_labelVolume: "Volume:",
	ui_labelWeapons: "Weapons:",
	ui_loadingLabel: "Loading",
	ui_recharging: "Recharging ($1)",
	ui_radioButtonEnglish: "English",
	ui_radioButtonPortuguese: "Português",
	ui_savedGameFound: "Saved game found",
	ui_advancedLabel: "Advanced",
	ui_seedPlaceholder: "Seed (optional)",
	ui_youalsosee: "You also see:",
	ui_vendBuyTab: "Buy",
	ui_vendSellTab: "Sell",
	ui_vendConfirmSale: "Confirm Sale",
	ui_vendSoldOut: "SOLD OUT",
	ui_vendNoOffers: "No items for sale.",
	ui_vendNothingToSell: "Nothing to sell.",
	ui_vendEach: "each",
	ui_vendPackSuffix: "(pack of {n})",
	ui_vendGoldLabel: "Cash: ",
	ui_vendLeft: "left",
	ui_vendReceiveTotal: "You will receive: ",
	ui_yousee: "You see:",
	ui_itemUse: "USE",
	ui_itemEnable: "ENABLE",
	ui_itemDisable: "DISABLE",
	ui_itemStateOn: "ON",
	ui_itemStateOff: "OFF",
};
